import { render } from "./ProjectReports.vue?vue&type=template&id=0ffa349a"
import script from "./ProjectReports.vue?vue&type=script&lang=js"
export * from "./ProjectReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__